import React from 'react';
import type { LucideIcon } from 'lucide-react';

export interface LegislationDeepLinkBannerProps {
  icon: LucideIcon;
  label: string;
  entityName: string;
  suffix?: string;
  onClear: () => void;
}

const LegislationDeepLinkBanner: React.FC<LegislationDeepLinkBannerProps> = ({
  icon: Icon,
  label,
  entityName,
  suffix,
  onClear,
}) => (
  <div className="mb-4 p-3 bg-info-50 dark:bg-info-900/20 border border-info-200 dark:border-info-800 rounded-lg">
    <div className="flex items-center justify-between gap-3">
      <div className="flex flex-wrap items-center gap-2 min-w-0">
        <Icon className="w-4 h-4 text-info-600 dark:text-info-400 flex-shrink-0" />
        <span className="text-sm font-medium text-text-primary dark:text-text-dark-primary">
          {label} <strong>{entityName}</strong>
        </span>
        {suffix && (
          <span className="text-sm text-info-700 dark:text-info-300">({suffix})</span>
        )}
      </div>
      <button
        type="button"
        onClick={onClear}
        className="text-sm font-medium text-info-700 dark:text-info-300 hover:text-info-900 dark:hover:text-info-100 flex-shrink-0"
      >
        Clear Filter
      </button>
    </div>
  </div>
);

export default LegislationDeepLinkBanner;
